// careUtils.js — shared constants/helpers for the student-care module
// (biweekly learning-behavior assessment, concern flags, intervention log).
// Enum keys mirror server/models/careModel.js — keep the two in sync.

export const LB_FIELDS = ['lb_attention', 'lb_participation', 'lb_readiness', 'lb_submission'];

export const LB_LABELS = {
  lb_attention: 'ความตั้งใจเรียน',
  lb_participation: 'การมีส่วนร่วม',
  lb_readiness: 'ความพร้อม/อุปกรณ์',
  lb_submission: 'การส่งงานตรงเวลา',
};

// 1-3 rating scale; default is 2 (ปกติ) so teachers only touch exceptions
export const LB_RATINGS = [
  { value: 1, label: 'ต้องปรับปรุง', variant: 'danger' },
  { value: 2, label: 'ปกติ', variant: 'secondary' },
  { value: 3, label: 'ดี', variant: 'success' },
];

export const CONCERN_CATEGORIES = {
  learning: 'ด้านการเรียน',
  health: 'ด้านสุขภาพ',
  family: 'ด้านครอบครัว',
  emotional: 'ด้านอารมณ์/จิตใจ',
  peer: 'ด้านเพื่อน/สังคม',
  other: 'อื่นๆ',
};

export const CONCERN_STATUS = {
  open: { label: 'รอดำเนินการ', variant: 'danger' },
  in_progress: { label: 'กำลังช่วยเหลือ', variant: 'warning' },
  resolved: { label: 'ยุติแล้ว', variant: 'success' },
};

export const IV_ACTIONS = {
  remedial: 'สอนซ่อมเสริม',
  counsel: 'ตักเตือน/พูดคุย',
  notify_advisor: 'แจ้งครูที่ปรึกษา',
  notify_parent: 'แจ้งผู้ปกครอง',
  refer_discipline: 'ส่งต่อฝ่ายปกครอง',
  other: 'อื่นๆ',
};

const TH_MONTHS_SHORT = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

export const formatThaiDate = (isoDate, { year = true } = {}) => {
  if (!isoDate) return '-';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoDate));
  if (!m) return String(isoDate);
  const be = Number(m[1]) + 543;
  const day = Number(m[3]);
  const month = TH_MONTHS_SHORT[Number(m[2]) - 1];
  return year ? `${day} ${month} ${be}` : `${day} ${month}`;
};

// A round is 14 days from its start Monday → label "23 มิ.ย. – 6 ก.ค. 2569"
export const formatRoundLabel = (roundStart) => {
  if (!roundStart) return '-';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(roundStart));
  if (!m) return String(roundStart);
  const end = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + 13, 12);
  const endIso = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;
  return `${formatThaiDate(roundStart, { year: false })} – ${formatThaiDate(endIso)}`;
};

// Shift a round start by ±n rounds (14 days each), returns YYYY-MM-DD
export const shiftRound = (roundStart, rounds) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(roundStart));
  if (!m) return roundStart;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + rounds * 14, 12);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
